import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as qs from 'query-string';
import { Dispatch, connect } from 'react-redux';
import {
    IDutyOfficerScheduleState, IAppState, IDutyOfficerScheduleListResponse, AppActionCreators, IApplicationState,
    DutyOfficerScheduleActionCreators, IDutyOfficerSchedulesResponse, IDutyOfficerScheduleResponse, IStaffListResponse
} from '@nkr/store/index';
import { ITimeSlot, days, IDayHour, IDayWithHours } from './models';
import { IDutyOfficerSchedule, IDutyOfficerScheduleRequest } from '@nkr/models/index';
import { DisplayType } from '@nkr/enums/index';
import { ToggleButtonGroup, ToggleButton, Button, Glyphicon, FormControl } from 'react-bootstrap';
import AddEditTimeSlot from './add-edit-timeslot';
import DeleteTimeSlot from './delete-timeslot';
import { ContainerWrapper } from './styles';
import * as DateTimeModule from "react-datetime";

const DateTime = (DateTimeModule as any).default;

interface IOwnProps { }

interface IStateProps {
    schedule: IDutyOfficerScheduleState,
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getSchedule: () => Promise<IDutyOfficerScheduleListResponse>,
    saveTimeSlots: (requestList: IDutyOfficerScheduleRequest[]) => Promise<IDutyOfficerSchedulesResponse>,
    saveTimeSlot: (request: IDutyOfficerScheduleRequest) => Promise<IDutyOfficerScheduleResponse>,
    removeTimeSlot: (id: number) => Promise<IDutyOfficerScheduleResponse>,
    getStaffList: () => Promise<IStaffListResponse>,
    changeDisplay: (display: number) => void
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    loading: boolean,
    selectedOfficers: number[],
    hourWithFocus: {
        day: number,
        hour: number
    },
    selection: IDayHour[],
    event: {
        show: boolean,
        data: ITimeSlot[]
    },
    delete: {
        show: boolean,
        data: IDutyOfficerSchedule
    },
    autoRefresh: number,
    officerList: { id: number, backgroundColor: string, color: string }[],
    hours: number[],
    isDragging: boolean,
    dragStart: { day: number, hour: number } | null,
    dragEnd: { day: number, hour: number } | null
}

class DutyOfficerSchedule extends React.Component<TProps, IState> {
    readonly state: IState = {
        loading: false,
        selectedOfficers: [],
        hourWithFocus: {
            day: 0,
            hour: 0
        },
        selection: [],
        event: {
            show: false,
            data: []
        },
        delete: {
            show: false,
            data: null
        },
        autoRefresh: 0,
        officerList: [],
        hours: _.range(0, 24),
        isDragging: false,
        dragStart: null,
        dragEnd: null
    }

    refreshInterval: any;

    componentDidMount = () => {
        let parsed = qs.parse(window.location.search);
        let show = parsed.show ? parseInt(parsed.show) : this.props.app.display;
        let autoRefresh = parsed.refresh ? parseInt(parsed.refresh) : 0;

        this.props.changeDisplay(show);

        this.setState({
            autoRefresh
        }, () => {
            this.getData();
        });


        document.addEventListener('mouseup', this.handleMouseUp);
    }

    componentWillUnmount = () => {

        document.removeEventListener('mouseup', this.handleMouseUp);

        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }

    refresh = () => {
        this.setState({
            loading: true
        }, () => {
            this.props.getSchedule().then(response => {
                this.setState({
                    loading: false
                });
            });
        });
    }

    getData = () => {
        this.props.showLoading('Loading schedule, one moment please...').then(() => {
            Promise.all([
                this.props.getSchedule(),
                this.props.getStaffList()
            ]).then(([scheduleResponse]) => {
                if (scheduleResponse.data.success) {
                    const scheduledOfficerIds = [...new Set(scheduleResponse.data.results.map(item => item.officerId))];
                    this.setState({ selectedOfficers: scheduledOfficerIds });
                }
                this.props.hideLoading();
            });
        });
    }

    handleDisplayChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.props.changeDisplay(parseInt(e.target.value));
    }

    handleRefresh = () => {
        this.refresh();
    }

    handleAutoRefreshChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            autoRefresh: parseInt(e.currentTarget.value)
        }, () => {
            clearInterval(this.refreshInterval);

            if (this.state.autoRefresh > 0)
                this.refreshInterval = setInterval(() => this.refresh(), this.state.autoRefresh * 1000);
        });
    }

    handleOfficerChange = (officer: number) => {
        let selectedOfficers = [...this.state.selectedOfficers];

        if (selectedOfficers.indexOf(officer) >= 0) {
            selectedOfficers = selectedOfficers.filter(x => x != officer);
        } else {
            selectedOfficers.push(officer);
        }

        this.setState({
            selectedOfficers
        });
    }

    handleOfficerToggleGroupChange = (valueOrEvent: React.FormEvent<any> | number[]) => {
        const val = Array.isArray(valueOrEvent) ? valueOrEvent : (valueOrEvent?.target as any)?.value;
        this.setState({ selectedOfficers: Array.isArray(val) ? val : [] });
    }

    handleEdit = (scheduleId: number) => {
        let data = this.props.schedule.list.find(x => x.id == scheduleId);
        let { id, dayId: day, startTime, startTimeRaw, endTime, endTimeRaw, officerId } = data;

        this.setState({
            event: {
                show: true,
                data: [{
                    id,
                    day,
                    startTime,
                    startTimeRaw,
                    endTime,
                    endTimeRaw,
                    officerId,
                    overlap: false
                }]
            }
        });
    }

    handleScheduleHighlightedTimeSlots = () => {
        let sortedOfficers = _.sortBy(this.getDutyOfficers(), x => x.firstName);
        let list: IDayWithHours[] = [];

        let selection = _.orderBy(this.state.selection, [(item: IDayHour) => {
            return item.day;
        }, (item: IDayHour) => {
            return item.hour;
        }]);

        let day = 0;
        let hours: number[] = [];

        selection.forEach((item, index) => {
            let dwh: IDayWithHours = null;

            if (day != item.day || (day == item.day && hours[hours.length - 1] != item.hour - 1)) {
                day = item.day;
                hours = [item.hour];

                if (dwh == null) {
                    dwh = {
                        day,
                        hours
                    };

                    list.push(dwh);
                }
            } else if (day == item.day && hours[hours.length - 1] == item.hour - 1) {
                hours.push(item.hour);
            }
        });

        let timeSlots = list.map(item => {
            let startTimeRaw = _.min(item.hours);
            let startTime = startTimeRaw.toString().length == 1 ? `0${startTimeRaw}:00` : `${startTimeRaw}:00`;
            let maxHour = _.max(item.hours);
            let endTimeRaw = parseInt(maxHour.toString() + '59');
            let endTime = endTimeRaw < 1000 ? `0${maxHour}:59` : `${maxHour}:59`;
            let overlapRange = _.range(startTimeRaw, endTimeRaw, 100);

            let overlapping = this.props.schedule.list.filter(x => x.dayId == day && (overlapRange.indexOf(x.startTimeRaw) >= 0 || overlapRange.find(y => y + 59 == x.endTimeRaw) != null));

            let timeSlot: ITimeSlot = {
                id: 0,
                day: item.day,
                startTime,
                startTimeRaw: startTimeRaw * 100,
                endTime,
                endTimeRaw,
                officerId: sortedOfficers[0].id,
                overlap: overlapping.length > 0
            };

            return timeSlot;
        });

        this.setState({
            event: {
                show: true,
                data: timeSlots
            }
        });
    }

    handleClearHighlightedTimeSlots = () => {
        this.setState({
            selection: []
        });
    }

    handleSelectDay = (day: number) => {
        let selection = _.cloneDeep(this.state.selection);
        let hours = _.range(0, 24);

        hours.forEach(hour => {
            let alreadyExists = selection.find(x => x.day == day && x.hour == hour) != null;

            if (!alreadyExists)
                selection.push({
                    day,
                    hour
                });
        });

        this.setState({
            selection
        });
    }

    handleCancelTimeSlot = () => {
        this.setState({
            event: { ...this.state.event, show: false }
        });
    }

    handleSaveTimeSlot = (list: ITimeSlot[]) => {
        this.props.showLoading('Adding to schedule, one moment please...').then(() => {
            var requestList: IDutyOfficerScheduleRequest[] = list.map(item => {
                let r: IDutyOfficerScheduleRequest = {
                    id: item.id,
                    dayId: item.day,
                    startTime: item.startTime,
                    endTime: item.endTime,
                    officerId: item.officerId
                };

                return r;
            });

            this.props.saveTimeSlots(requestList).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    const officerIds = list.map(item => item.officerId);
                    this.setState({
                        selectedOfficers: [...new Set([...this.state.selectedOfficers, ...officerIds])],
                        selection: [],
                        event: {
                            show: false,
                            data: null
                        }
                    });
                }
            });
        });
    }

    handleUpdateTimeSlot = (item: ITimeSlot) => {
        this.props.showLoading('Updating schedule, one moment please...').then(() => {
            var request: IDutyOfficerScheduleRequest = {
                id: item.id,
                dayId: item.day,
                startTime: item.startTime,
                endTime: item.endTime,
                officerId: item.officerId
            };

            this.props.saveTimeSlot(request).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    if (!this.state.selectedOfficers.includes(item.officerId)) {
                        this.setState({
                            selectedOfficers: [...this.state.selectedOfficers, item.officerId],
                            selection: [],
                            event: {
                                show: false,
                                data: null
                            }
                        });
                    } else {
                        this.setState({
                            selection: [],
                            event: {
                                show: false,
                                data: null
                            }
                        });
                    }
                }
            });
        });
    }

    handleDeleteConfirm = (scheduleId: number) => {
        this.setState({
            delete: {
                show: true,
                data: this.props.schedule.list.find(x => x.id == scheduleId)
            }
        });
    }

    handleCancelTimeSlotDelete = () => {
        this.setState({
            delete: { ...this.state.delete, show: false }
        });
    }

    handleDeleteTimeSlot = (id: number) => {
        this.props.showLoading('Deleting from schedule, one moment please...').then(() => {
            this.props.removeTimeSlot(id).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    this.setState({
                        delete: {
                            show: false,
                            data: null
                        }
                    });
                }
            });
        });
    }

    handleMouseDown = (day: number, hour: number) => {
        this.setState({
            isDragging: true,
            dragStart: { day, hour },
            dragEnd: { day, hour }
        });
    }

    handleMouseEnter = (day: number, hour: number) => {
        this.setState({
            hourWithFocus: {
                day,
                hour
            }
        });


        if (this.state.isDragging) {
            this.setState({
                dragEnd: { day, hour }
            });
        }
    }

    handleMouseUp = () => {
        if (this.state.isDragging && this.state.dragStart && this.state.dragEnd) {

            const { dragStart, dragEnd } = this.state;
            if (dragStart.day !== dragEnd.day || dragStart.hour !== dragEnd.hour) {
                this.handleDragSelection();
            }
        }

        this.setState({
            isDragging: false,
            dragStart: null,
            dragEnd: null
        });
    }

    handleDragSelection = () => {
        if (!this.state.dragStart || !this.state.dragEnd) return;

        const { dragStart, dragEnd } = this.state;
        let selection = [...this.state.selection];

        const startDay = Math.min(dragStart.day, dragEnd.day);
        const endDay = Math.max(dragStart.day, dragEnd.day);
        const startHour = Math.min(dragStart.hour, dragEnd.hour);
        const endHour = Math.max(dragStart.hour, dragEnd.hour);
        for (let day = startDay; day <= endDay; day++) {
            for (let hour = startHour; hour <= endHour; hour++) {
                const existingIndex = selection.findIndex(x => x.day === day && x.hour === hour);
                if (existingIndex === -1) {
                    selection.push({ day, hour });
                } else {
                    selection.splice(existingIndex, 1);
                }
            }
        }

        this.setState({
            selection
        });
    }

    handleAvailableClick = (day: number, hour: number) => {
        if (this.state.isDragging && this.state.dragStart && this.state.dragEnd) {
            const { dragStart, dragEnd } = this.state;
            if (dragStart.day !== dragEnd.day || dragStart.hour !== dragEnd.hour) {
                return;
            }
        }

        let selection = [...this.state.selection];

        if (selection.find(x => x.day == day && x.hour == hour) != null) {
            selection = selection.filter(x => {
                return !(x.day == day && x.hour == hour);
            });
        } else {
            selection.push({
                day,
                hour
            });
        }

        this.setState({
            selection
        });
    }

    getTimeSlots = (dayId: number) => {
        let results = [];
        let hour = 0;

        while (hour < this.state.hours.length) {
            let hourId = hour;
            let hourStart = hour * 100;
            let hourEnd = hour * 100 + 59;

            let existing = this.props.schedule.list.find(x => x.dayId == dayId && x.startTimeRaw <= hourStart && x.endTimeRaw >= hourEnd);
            let isFirst = this.props.schedule.list.find(x => x.dayId == dayId && hourStart == x.startTimeRaw) != null;
            let staff = this.getDutyOfficers().find(x => x.id == (existing ? existing.officerId : 0));
            let display = existing && staff ? this.state.selectedOfficers.indexOf(existing.officerId) >= 0 : false;

            if (existing && display && staff) {
                let backgroundColor = staff.backgroundColor || '#f0f0f0';
                let color = staff.color || '#000000';

                results.push(
                    <div
                        key={'day' + dayId + '/hour' + hour}
                        style={{
                            height: 37.5,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderWidth: '0px 1px 1px 0px',
                            borderStyle: 'solid',
                            borderColor: '#ccc',
                            backgroundColor,
                            color,
                            padding: 5
                        }}
                    >
                        {isFirst && (
                            <>
                                <div>{existing.officer.firstName}</div>
                                <div>
                                    <Glyphicon glyph='cog' onClick={() => this.handleEdit(existing.id)} />
                                    <Glyphicon glyph='remove' onClick={() => this.handleDeleteConfirm(existing.id)} />
                                </div>
                            </>
                        )}
                    </div>
                );
            } else {
                let backgroundColor = this.state.hourWithFocus.day == dayId && this.state.hourWithFocus.hour == hour ? 'bg-warning' : '';
                backgroundColor = this.state.selection.find(x => x.day == dayId && x.hour == hour) != null ? 'bg-selection' : backgroundColor;

                results.push(
                    <div
                        key={'day' + dayId + '/hour' + hour}
                        className={`time-slot ${backgroundColor}`}
                        style={{
                            height: 37.5,
                            display: 'flex',
                            alignItems: 'center',
                            borderWidth: '0px 1px 1px 0px',
                            borderStyle: 'solid',
                            borderColor: '#ccc'
                        }}
                        onClick={() => this.handleAvailableClick(dayId, hourId)}
                        onMouseDown={() => this.handleMouseDown(dayId, hourId)}
                        onMouseEnter={() => this.handleMouseEnter(dayId, hourId)}
                    >
                        &nbsp;
                    </div>
                );
            }

            hour++;
        }

        return results;
    }

    getDutyOfficers = () => {
        // console.log(this.props.schedule.staffList)
        let dutyOfficers = this.props.schedule.staffList.filter(x => {
            //return x.titles.includes('Duty Officer');
            // return x.positions.map(x => x.id).indexOf(NkrContactPosition.DutyOfficer) >= 0;
            return true;
        });

        return dutyOfficers;
    }

    render = () => {
        const width = 95 / 7;
        const officerList = _.sortBy(this.getDutyOfficers(), item => item.firstName);
        const marginTop = this.props.app.display == DisplayType.NoMenuNoTabs ? 10 : 0;

        return (
            <>
                <ContainerWrapper className='container-fluid'>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 30, marginBottom: 20, marginTop }}>

                        {/* Left: Title */}
                        <div style={{ flex: 1, fontSize: 28, fontWeight: 500 }}>
                            DUTY OFFICER SCHEDULE
                        </div>

                        {/* Center: Officers */}
                        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ marginRight: 8 }}>Officers:</div>
                            <div>
                                <ToggleButtonGroup
                                    type='checkbox'
                                    name='officers'
                                    value={this.state.selectedOfficers}
                                    onChange={this.handleOfficerToggleGroupChange as any}
                                >
                                    {officerList.map(officer => {
                                        let backgroundColor = officer.backgroundColor;
                                        let color = officer.color;

                                        return (
                                            <ToggleButton
                                                key={'toggle-button-' + officer.id}
                                                type='checkbox'
                                                value={officer.id}
                                                className='btn-sm'
                                                style={{ backgroundColor, color }}
                                            >
                                                {officer.firstName}
                                            </ToggleButton>
                                        );
                                    })}
                                </ToggleButtonGroup>
                            </div>
                        </div>

                        {/* Right: Buttons */}
                        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                            <Button bsStyle='primary' bsSize='xs' disabled={this.state.selection.length == 0} onClick={this.handleScheduleHighlightedTimeSlots}>
                                Schedule Highlighted Timeslot
                            </Button>
                            <Button bsSize='xs' disabled={this.state.selection.length == 0} onClick={this.handleClearHighlightedTimeSlots}>
                                Clear Highlighted Timeslot(s)
                            </Button>
                        </div>

                    </div>
                </ContainerWrapper>


                <ContainerWrapper className='container-fluid'>
                    <div className='row'>
                        <div className='col-xs-1' style={{ width: '5%', borderWidth: '1px 1px 0px 1px', borderStyle: 'solid', borderColor: '#ddd', height: 37.5 }}>&nbsp;</div>
                        {days.map(day =>
                            <div
                                key={'day-header-' + day.id}
                                className='col-xs-1'
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: width + '%',
                                    borderWidth: '1px 1px 1px 0px',
                                    borderStyle: 'solid',
                                    borderColor: '#ddd',
                                    textAlign: 'center',
                                    height: 37.5
                                }}
                            >
                                <Button bsStyle='link' style={{ padding: 0, fontWeight: 700 }} onClick={() => this.handleSelectDay(day.id)}>{day.name}</Button>
                            </div>
                        )}
                    </div>

                    <div
                        className='row schedule-grid'
                        onMouseUp={this.handleMouseUp}
                        onMouseLeave={this.handleMouseUp}
                    >
                        <div className='col-xs-1' style={{ width: '5%', padding: 0, borderBottom: '1px solid #ddd' }}>
                            {this.state.hours.map(hour => {
                                const h = moment().hour(hour).minute(0).format('HH:mm');

                                return (
                                    <div
                                        key={'hour' + hour}
                                        style={{
                                            width: '100%',
                                            height: 37.5,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            borderWidth: '1px 1px 1px 1px',
                                            borderStyle: 'solid',
                                            borderColor: '#ddd'
                                        }}
                                    >
                                        <div style={{ fontWeight: 700 }}>{h}</div>
                                    </div>
                                );
                            })}
                        </div>

                        {days.map(day =>
                            <div key={'/day-row-' + day.id} className='col-xs-1' style={{ width: width + '%', padding: 0 }}>
                                {this.getTimeSlots(day.id)}
                            </div>
                        )}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 8 }}>
                        <div style={{ marginRight: 5, fontSize: 12 }}>Show:</div>
                        <select
                            key={this.props.app.display}
                            defaultValue={this.props.app.display}
                            className='form-control'
                            style={{ fontSize: 12, padding: '3px 6px', height: 26, width: 'auto' }}
                            onChange={this.handleDisplayChange}
                        >
                            <option value={1}>Menus</option>
                            <option value={4}>No Menus</option>
                        </select>
                    </div>
                </ContainerWrapper>

                <AddEditTimeSlot
                    show={this.state.event.show}
                    data={this.state.event.data}
                    days={days}
                    hours={this.state.hours}
                    officers={officerList}
                    existing={this.props.schedule.list}
                    onCancel={this.handleCancelTimeSlot}
                    onSave={this.handleSaveTimeSlot}
                    onUpdate={this.handleUpdateTimeSlot}
                />

                <DeleteTimeSlot
                    show={this.state.delete.show}
                    data={this.state.delete.data}
                    days={days}
                    hours={this.state.hours}
                    officers={officerList}
                    onCancel={this.handleCancelTimeSlotDelete}
                    onDelete={this.handleDeleteTimeSlot}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        schedule: appState.dutyOfficerSchedule,
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getSchedule: () => {
            return dispatch(DutyOfficerScheduleActionCreators.getSchedule());
        },
        saveTimeSlots: (requestList) => {
            return dispatch(DutyOfficerScheduleActionCreators.saveTimeSlots(requestList));
        },
        saveTimeSlot: (request) => {
            return dispatch(DutyOfficerScheduleActionCreators.saveTimeSlot(request));
        },
        removeTimeSlot: (id) => {
            return dispatch(DutyOfficerScheduleActionCreators.removeTimeSlot(id));
        },
        getStaffList: () => {
            return dispatch(DutyOfficerScheduleActionCreators.getStaffList());
        },
        changeDisplay: (display: number) => {
            dispatch(AppActionCreators.changeDisplay(display));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DutyOfficerSchedule);